export const SENTIMENTS = [
    'Negative',
    'NegativeToNeutral',
    'NeutralToNegative',
    'Neutral',
    'NeutralToPositive',
    'PositiveToNeutral',
    'Positive',
];

const SENTIMENT_TOKENS: Record<string, string> = {
    Negative: 'sentiment-negative',
    NegativeToNeutral: 'sentiment-negative-to-neutral',
    NeutralToNegative: 'sentiment-neutral-to-negative',
    Neutral: 'sentiment-neutral',
    NeutralToPositive: 'sentiment-neutral-to-positive',
    PositiveToNeutral: 'sentiment-positive-to-neutral',
    Positive: 'sentiment-positive',
};

export function sentimentColor(sentiment: string) {
    const token = SENTIMENT_TOKENS[sentiment];

    return token ? `bg-${token}` : 'bg-gray-500';
}

/**
 * The sentiment's `--color-*` variable, for contexts like `color-mix()`
 * that need the raw variable rather than a Tailwind class.
 */
export function sentimentCssVariable(sentiment: string) {
    const token = SENTIMENT_TOKENS[sentiment];

    return token ? `--color-${token}` : '--color-gray-medium';
}
